import { raundColors } from '@/theme/colors'
import { Textarea as MantineTextarea } from '@mantine/core'
import type React from 'react'
import styles from './Textarea.module.css'

// ─────────────────────────────────────────────
// 型定義
// ─────────────────────────────────────────────
export type TextareaStatus = 'normal' | 'error'

export type TextareaProps = {
  status?: TextareaStatus
  value?: string
  defaultValue?: string
  onChange?: (value: string) => void
  onBlur?: () => void
  placeholder?: string
  rows?: number
  style?: React.CSSProperties
  className?: string
  id?: string
  name?: string
  readOnly?: boolean
  disabled?: boolean
}

// ─────────────────────────────────────────────
// ステータス別 CSS 変数
// ─────────────────────────────────────────────
const STATUS_VARS: Record<TextareaStatus, Record<string, string>> = {
  normal: {
    '--input-bd': raundColors.black,
    '--input-bg': raundColors.white,
    '--input-color': raundColors.black,
  },
  error: {
    '--input-bd': raundColors.danger.base,
    '--input-bg': raundColors.white,
    '--input-color': raundColors.black,
  },
}

// ─────────────────────────────────────────────
// コンポーネント
// ─────────────────────────────────────────────
export const Textarea = ({
  status = 'normal',
  value,
  defaultValue,
  onChange,
  onBlur,
  placeholder,
  rows = 4,
  style,
  className,
  id,
  name,
  readOnly,
  disabled,
}: TextareaProps) => {
  const vars = STATUS_VARS[status]

  return (
    <MantineTextarea
      value={value}
      defaultValue={defaultValue}
      onChange={(e) => onChange?.(e.currentTarget.value)}
      onBlur={onBlur}
      placeholder={placeholder}
      rows={rows}
      readOnly={readOnly}
      disabled={disabled}
      id={id}
      name={name}
      // iOS Safari の自動ズーム防止のため input に直接 font-size を指定する
      styles={{ wrapper: { ...vars } as React.CSSProperties, input: { fontSize: '16px' } as React.CSSProperties }}
      style={style}
      className={className}
      classNames={{
        root: styles.root,
        input: styles.textarea,
      }}
    />
  )
}
